"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Edit;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Edit(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "edit"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M90,83.677H10a2.5,2.5,0,0,0,0,5H90a2.5,2.5,0,0,0,0-5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.908,75.534c.062,0,.124,0,.187-.007l11.673-.876a2.5,2.5,0,0,0,1.527-.673L76.6,26.6a3.368,3.368,0,0,0,.146-4.761l-8.909-9.461a3.369,3.369,0,0,0-4.761-.145L12.769,59.614a2.5,2.5,0,0,0-.764,1.484L10.431,72.7a2.5,2.5,0,0,0,2.477,2.837ZM65.318,17l6.671,7.085L66.64,29.119l-6.671-7.084ZM16.841,62.647,56.328,25.463,63,32.547,23.512,69.731,15.8,70.31Z"
  })))));
}